<template>
  <div class="flex flex-col w-full my-12 py-8 px-6 space-y-6 border rounded-lg bg-[#FFFFFF0D] border-[#ffffff1a]">
    <div class="space-y-2">
      <h2 class="text-center uppercase">{{ t('auth.login.sign-in-title') }}</h2>
      <p class="text-sm text-center text-muted-foreground">{{ t('auth.login.sign-in-description') }}</p>
    </div>
    <LoginSocial class="w-full" @on-success="emit('login-success')" />
    <Separator :label="t('auth.login.or-continue-with-email')" class="separator my-6" />
    <LoginForm @login-success="emit('login-success')" />

    <div v-if="props.onBack" class="flex flex-col w-full items-center justify-center space-y-4">
      <Button variant="ghost" size="sm" class="text-muted-foreground flex items-center gap-x-1" @click="props.onBack">
        <ArrowLeftIcon class="w-4 h-4" />
        {{ t('auth.login.back-button') }}
      </Button>
    </div>

    <slot name="footer" />
  </div>
</template>

<script setup lang="ts">
import { ArrowLeftIcon } from 'lucide-vue-next'

const props = defineProps<{
  onBack?: () => void
}>()

const emit = defineEmits<{
  (e: 'login-success'): void
}>()

const { t } = useI18n()
</script>

<style scoped>
:deep(.separator > span) {
  background-color: #1b5275;
}
</style>
